
import '../styles/theme.css';

export default function MentionsLegales() {
    return (
        <>
            <div className="container" style={{ padding: '60px 20px', maxWidth: '800px' }}>
                <h1 style={{ marginBottom: '40px', fontSize: '32px', borderBottom: '2px solid var(--accent)', display: 'inline-block', paddingBottom: '10px' }}>
                    Mentions Légales
                </h1>

                <section style={{ marginBottom: '32px' }}>
                    <h2 style={{ fontSize: '20px', color: 'var(--accent-600)', marginBottom: '16px' }}>1. Éditeur du site</h2>
                    <p style={{ lineHeight: '1.6', color: '#374151' }}>
                        Le présent site est édité par la société <strong>AUTOMATISMES ELECTRICITE FERMETURES 32 (AEF32)</strong>,
                        Société par actions simplifiée (SAS) au capital de 1 000,00 €, immatriculée au Registre du Commerce et des Sociétés sous le numéro 909 916 884.
                    </p>
                    <ul style={{ listStyle: 'none', padding: 0, lineHeight: '1.8', color: '#374151', marginTop: '10px' }}>
                        <li><strong>Siège social :</strong> 2 CHEMIN DES RELIGIEUSES, 32220 LOMBEZ</li>
                        <li><strong>SIRET :</strong> 909 916 884 00028</li>
                        <li><strong>Numéro de TVA intracommunautaire :</strong> FR41909916884</li>
                        <li><strong>Directeur de la publication :</strong> Alexandre MAGRANER</li>
                        <li><strong>Activité (Code NAF/APE) :</strong> 4322B (Travaux d'installation d'équipements thermiques et de climatisation)</li>
                    </ul>
                </section>

                <section style={{ marginBottom: '32px' }}>
                    <h2 style={{ fontSize: '20px', color: 'var(--accent-600)', marginBottom: '16px' }}>2. Hébergement</h2>
                    <p style={{ lineHeight: '1.6', color: '#374151' }}>
                        Le site est hébergé par :<br />
                        <strong>Infocolab</strong><br />
                        Site web : <a href="https://infocolab.online" target="_blank" rel="noreferrer" style={{ color: 'var(--accent)' }}>https://infocolab.online</a>
                    </p>
                </section>

                <section style={{ marginBottom: '32px' }}>
                    <h2 style={{ fontSize: '20px', color: 'var(--accent-600)', marginBottom: '16px' }}>3. Propriété intellectuelle</h2>
                    <p style={{ lineHeight: '1.6', color: '#374151' }}>
                        L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle.
                        Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
                        La reproduction de tout ou partie de ce site sur quelque support que ce soit est formellement interdite sauf autorisation expresse du directeur de la publication.
                    </p>
                </section>

                <section style={{ marginBottom: '32px' }}>
                    <h2 style={{ fontSize: '20px', color: 'var(--accent-600)', marginBottom: '16px' }}>4. Données personnelles</h2>
                    <p style={{ lineHeight: '1.6', color: '#374151' }}>
                        Pour toute information relative à la collecte et au traitement de vos données personnelles, nous vous invitons à consulter notre
                        <a href="/politique-de-confidentialite" style={{ color: 'var(--accent)', marginLeft: '5px' }}>Politique de Confidentialité</a>.
                    </p>
                </section>

                <section style={{ marginBottom: '32px' }}>
                    <h2 style={{ fontSize: '20px', color: 'var(--accent-600)', marginBottom: '16px' }}>5. Contact</h2>
                    <p style={{ lineHeight: '1.6', color: '#374151' }}>
                        Pour toute question ou demande d'information concernant le site, ou toute notification de contenu illicite,
                        vous pouvez nous contacter via notre <a href="/contact" style={{ color: 'var(--accent)' }}>formulaire de contact</a>.
                    </p>
                </section>
            </div>
        </>
    );
}
